<custom-navbar barTitle="아이디 / 비밀번호 찾기" [showSetting]="false"></custom-navbar>
<div class="find-privacy-wrap">
    <p class="title">아이디 찾기</p>
    <form (ngSubmit)="onSubmitId()">
      <input class="input" [(ngModel)]="userName" name="name" type="text" placeholder="이름을 입력해주세요" required>
      <input class="input" [(ngModel)]="userPhoneEmail" name="email" type="text" placeholder="이메일 혹은 전화번호를 입력해주세요" required>
      <div class="warning"># 전화번호는 "-" 없이 입력해주세요</div>
      <button class="id-btn" mat-button type="submit">아이디 찾기</button>
    </form>
    <p class="title">비밀번호 찾기</p>
    <form (ngSubmit)="onSubmitPw()">
      <input class="input" [(ngModel)]="userName" name="name" type="text" placeholder="이름을 입력해주세요" required>
      <input class="input" [(ngModel)]="userId" name="id" type="text" placeholder="아이디를 입력해주세요" required>
      <input class="input" [(ngModel)]="userPhoneNum" name="phone" type="text" placeholder="'-' 없이 전화번호를 입력해주세요" required>
      <button class="pw-btn" mat-button type="submit">비밀번호 찾기</button>
    </form>
</div>
